import React from 'react';

import { useMutation } from '@tanstack/react-query';

import Modal from '../../../../../../Modal';
import CrudForm from '../../../../../../Form/CrudForm';

import BankStatementTransactionService from '../../../../../../../services/BankStatementTransactionService';
import { useUiStore } from '../../../../../../../store';

const fields = [
  {
    label: 'Date',
    name: 'date',
    type: 'date',
  },
  {
    label: 'Description',
    name: 'description',
    type: 'text',
  },
  {
    label: 'Deposit Amount',
    name: 'depositAmount',
    type: 'currency',
  },
  {
    label: 'Deduction Amount',
    name: 'deductionAmount',
    type: 'currency',
  },
  {
    label: 'Excluded',
    name: 'isExcluded',
    type: 'checkbox',
  },
  {
    label: 'Exclusion Reason',
    name: 'exclusionReason',
    type: 'text',
  },
];

export default function TransactionEditModal({
  isVisible,
  hideModal,
  transaction,
  refetch,
}) {
  const notify = useUiStore((state) => state.notify);

  const { mutate: updateTransaction, isPending } = useMutation({
    mutationFn: (formValues) =>
      BankStatementTransactionService.updateBankStatementTransaction({
        formValues,
        id: transaction.id,
      }),
    onSuccess: () => {
      refetch();
      notify({ type: 'success', message: 'Transaction updated successfully' });
      hideModal();
    },
    onError: (error) => {
      console.log(error);
      notify({ type: 'error', message: 'Error updating transaction' });
    },
  });

  return (
    <Modal
      zIndex={1000}
      isVisible={isVisible}
      hideModal={hideModal}
      title="Edit Transaction"
    >
      <div className="pt-4 fle w-full">
        <CrudForm
          fields={fields}
          data={transaction}
          submitButtonLabel="Update"
          updateHandler={updateTransaction}
          isPending={isPending}
        />
      </div>
    </Modal>
  );
}
